import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import defaultAvatar from './assets/img/default-avatar.svg';
import { useMainStore } from './stores/index';
import ProgressBar from 'primevue/progressbar';
import FileUpload from 'primevue/fileupload';
import store from './store';
import router from './router';
import VueTilt from 'vue-tilt.js';
import VueSweetalert2 from 'vue-sweetalert2';
import ArgonDashboard from './argon-dashboard';
import mitt from 'mitt';
import PrimeVue from 'primevue/config';
import Image from 'primevue/image';
import OtpInput from 'vue3-otp-input';
import Tag from 'primevue/tag';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import InputText from 'primevue/inputtext';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import MultiSelect from 'primevue/multiselect';
import TreeTable from 'primevue/treetable';
import Checkbox from 'primevue/checkbox';
import TreeSelect from 'primevue/treeselect';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import ProgressSpinner from 'primevue/progressspinner';
import Chart from 'primevue/chart';
import Treeselects from '@zanmato/vue3-treeselect';
import InputSwitch from 'primevue/inputswitch';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Timeline from 'primevue/timeline';
import '@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'primeicons/primeicons.css';
import 'primevue/resources/primevue.min.css';
import 'primevue/resources/themes/mdc-light-indigo/theme.css';
import './assets/css/nucleo-icons.css';
import './assets/css/nucleo-svg.css';
import Tooltip from 'primevue/tooltip';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: 'umrettrtncsvyjt6i88n',
  wsHost: 'backend.smart2doc.com.br',
  wssHost: 'backend.smart2doc.com.br',
  authEndpoint: 'https://backend.smart2doc.com.br/broadcasting/auth/',
  wssPort: 6001,
  wsPort: 6001,
  encrypted: true,
  forceTLS: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss']
});

library.add(fas, fab, far);
const appInstance = createApp(App);
const pinia = createPinia();
appInstance.use(pinia);
appInstance.use(PrimeVue, {
  zIndex: {
    modal: 10000,
    overlay: 11000,
    menu: 11000,
    tooltip: 12000
  }
});
appInstance.use(ToastService);
appInstance.directive('tooltip', Tooltip);
appInstance.component('treeselects', Treeselects);
appInstance.component('Timeline', Timeline);
appInstance.component('Dropdown', Dropdown);
appInstance.component('Accordion', Accordion);
appInstance.component('AccordionTab', AccordionTab);
appInstance.component('InputSwitch', InputSwitch);
appInstance.component('spinnerprime', ProgressSpinner);
appInstance.component('ProgressBar', ProgressBar);
appInstance.component('font-awesome-icon', FontAwesomeIcon);
appInstance.component('PrimeChart', Chart);
appInstance.component('Tag', Tag);
appInstance.component('FileUpload', FileUpload);
appInstance.component('CodeInput', OtpInput);
appInstance.component('DataTable', DataTable);
appInstance.component('Paginator', Paginator);
appInstance.component('MultiSelectPrime', MultiSelect);
appInstance.component('Column', Column);
appInstance.component('ColumnGroup', ColumnGroup);
appInstance.component('InputText', InputText);
appInstance.component('Row', Row);
appInstance.component('Buttonprime', Button);
appInstance.component('Toast', Toast);
appInstance.component('TreeTable', TreeTable);
appInstance.component('Checkbox', Checkbox);
appInstance.component('TreeSelect', TreeSelect);
appInstance.component('ImagePrime', Image);
const emitter = mitt();
appInstance.config.globalProperties.emitter = emitter;
appInstance.config.globalProperties.$defaultAvatar = defaultAvatar;
appInstance.config.globalProperties.$userAvatar = function (path) {
  if (!path || typeof path !== 'string' || path === 'null' || path === 'undefined' || path === defaultAvatar || path.includes('default-avatar')) {
    return defaultAvatar;
  }
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:') || path.startsWith('blob:')) {
    return path;
  }
  let host;
  try {
    const mainStore = this?.Store || (pinia ? useMainStore(pinia) : null);
    host = mainStore?.host;
  } catch (e) {
    // fallback if pinia store is not ready
  }
  if (!host) {
    host = this?.$pinia?.state?.value?.main?.host || (process.env.VUE_APP_STORAGE_URL || 'http://localhost:8000/storage/');
  }
  if (path.startsWith(host)) {
    return path;
  }
  return host + path;
};

// Fallback global de imagem para avatares quebrados
if (typeof window !== 'undefined') {
  window.addEventListener('error', function (event) {
    const target = event.target;
    if (target && target.tagName === 'IMG') {
      if (target.dataset.fallbackApplied) return;
      const src = target.getAttribute('src') || target.src || '';
      const isAvatar =
        target.classList.contains('avatar') ||
        target.classList.contains('hover-image') ||
        target.style.borderRadius === '50%' ||
        target.style.borderRadius === '2rem' ||
        target.style.borderRadius === '1rem' ||
        src.includes('default-avatar') ||
        src.includes('/images/profile') ||
        src.includes('/null') ||
        src.includes('/undefined') ||
        target.alt === 'Avatar' ||
        target.alt === 'Foto de perfil';

      if (isAvatar) {
        target.dataset.fallbackApplied = 'true';
        target.src = defaultAvatar;
      }
    }
  }, true);
}

appInstance.use(store);
appInstance.use(router);
appInstance.use(VueTilt);
appInstance.use(VueSweetalert2);
appInstance.use(ArgonDashboard);
appInstance.mount('#app');
